import type { LinkProps } from '@mui/material/Link';

import { mergeClasses } from 'minimal-shared/utils';

import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import OnFitLogoIcon from 'src/assets/icons/onfit-logo-icon';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
  width?: number;
  height?: number;
};

export function Logo({
  sx,
  disabled,
  className,
  href = '/',
  isSingle = true,
  width,
  height,
  ...other
}: LogoProps) {
  const theme = useTheme();

  const PRIMARY_MAIN = theme.vars.palette.primary.main;

  const defaultWidth = isSingle ? 40 : 102;
  const defaultHeight = isSingle ? 40 : 36;
  const logoWidth = width ?? defaultWidth;
  const logoHeight = height ?? defaultHeight;

  return (
    <LogoRoot
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: logoWidth,
          height: logoHeight,
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <OnFitLogoIcon width={logoWidth} height={logoHeight} fill={PRIMARY_MAIN} />
    </LogoRoot>
  );
}

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
